import React from "react";
import { NodeProps, useEdges, useNodes, useReactFlow } from "reactflow";
import { operationType } from "../../../../../services/types";
import { Main, Styled } from "./style";
import { TextInput } from "../../../../form/textInput";
import { Switch } from "../../../../form/switch";
import { updateNodeValue } from "../../../../../services/method";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import axios from "axios";
import { webURL } from "../../../../../services/API";
import { useSearchParams } from "react-router-dom";
import { Textarea } from "../../../../form/textarea";
import { SettingsBlock, settingsDataType } from "../../../../settingsBlock";
import { IoCheckmarkCircleOutline, IoWarningOutline } from "react-icons/io5";
import { ExpandedBlock } from "../../../expanded";

type SequencerProps = NodeProps<operationType> & {
   setChildMinimize?: (fn: (id: string) => void) => void;
   setChildSettings?: (fn: (id: string) => void) => void;
};

interface sequencerType {
   id: number, message: string, objective: string, instructions: string,
   isMinimize: boolean, isWithRag: boolean, isReturning: boolean
}
let isFirst = true;

export function Sequencer({ id, data, setChildMinimize, setChildSettings }: SequencerProps) {
   const [isReturningToggle, setIsReturningToggle] = React.useState(false);
   const [isWebsiteToggle, setIsWebsiteToggle] = React.useState(false);
   const [searchParams] = useSearchParams();
   const { setNodes } = useReactFlow();
   const nodes = useNodes();
   const edges = useEdges();
   const [settings, setSettings] = React.useState<settingsDataType>({ isToggle: false });
   const [isExpanded, setIsExpanded] = React.useState(false);
   
   // --
   React.useEffect(() => {
      if (setChildMinimize) setChildMinimize(() => { setIsExpanded(prev => !prev) });
      if (setChildSettings) setChildSettings(() => { setSettings(prev => ({ ...prev, isToggle: !prev.isToggle })) });
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [setChildMinimize, setChildSettings]);

   // ---
   React.useEffect(() => {
      if (!data.value?.sequencers) {
         updateNodeValue(id, setNodes, { sequencers: [
            { id: 1, message: '', objective: '', instructions: '', isMinimize: false, isWithRag: false },
            { id: 2, message: '', objective: '', instructions: '', isMinimize: true, isWithRag: false },
            { id: 3, message: '', objective: '', instructions: '', isMinimize: false, isWithRag: false, isReturning: true },
         ]});
         // definition
         if (isFirst) {
            isFirst = false;
            axios.post(`${webURL}/conversations/sequencer?projectId=${searchParams.get('id')}`, { blockInx: data.index });
         }
      }
      // updateNodeValue(id, setNodes, { conversations: []});
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   // ---
   const handleAddExtractor = (type: 'add' | 'remove', value?: any) => {
      if (type === 'add') {
         updateNodeValue(id, setNodes, { 
            sequencers: [...data.value.sequencers, { 
               id: Date.now(), message: '', objective: '', instructions: '',
               isMinimize: true, isWithRag: false, isReturning: value
            }] 
         });
      } else {
         updateNodeValue(id, setNodes, { sequencers: data.value.sequencers.filter((item: any) => item.id !== value) });
      }
   }

   // ---
   const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>, keyRef?: string, otherKey?: any) => {
      if (otherKey) {
         updateNodeValue(id, setNodes, { sequencers: data.value.sequencers.map((item: any) => {
            if (item.id === otherKey) return { ...item, [keyRef as string]: e.target.value }
            return item;
         })});
      } else if (keyRef) {
         updateNodeValue(id, setNodes, { [keyRef]: e.target.value });
      }
   }

   // ---
   const handleDeleteHistory = async () => {
      if (window.confirm('Are you sure you want to delete conversations history?')) {
         await axios.delete(`${webURL}/conversations?projectId=${searchParams.get('id')}&blockInx=${data.index}`); 
         alert('It has been deleted!');
      }
   }

   // ---
   const isWebhook = nodes.some(node => (node.data as any).action === 'webhook' && edges.some(edge => edge.target === id && edge.source === node.id));
   const mainSequencers: sequencerType[] = data.value?.sequencers?.filter((sequencer: sequencerType) => !sequencer.isReturning);
   const returningSequencers: sequencerType[] = data.value?.sequencers?.filter((sequencer: sequencerType) => sequencer.isReturning);
   const isWarning = false;

   return (<>
      <SettingsBlock nodeId={ id }data={ settings } setData={ setSettings } />
      <Main>
         {isWarning ? <>
                <div id="warning"></div>
                <span id="warningIcon"><IoWarningOutline size={21} /></span>
            </> : data.output ? <>
                <div id="ran"></div>
                <span id="ranIcon"><IoCheckmarkCircleOutline size={21} /></span>
            </> : null}
         { isExpanded ? <ExpandedBlock
            data={{ id, ...data }} 
            handleClose={ () => setIsExpanded(false) } 
            isWarning={ isWarning }
            style={{ width: '420px' }}
         ><Styled>
         <div className="action">
            <button className={`btn1 ${mainSequencers?.length >= 10 ? 'disabled' : ''}`}  onClick={ _=> handleAddExtractor('add', false) }>Add Sequence</button>
            <button className="btn1 withBorder" onClick={ _=>{ setIsReturningToggle(toggle => !toggle); setIsWebsiteToggle(false); }}>Returning</button>
            <button className="btn1 withBorder delete" onClick={ handleDeleteHistory }>Delete History</button>
            { !isWebhook ? <button className="btn1 withBorder website" onClick={ _=> { setIsWebsiteToggle(toggle => !toggle); setIsReturningToggle(false); }}>Add to your website</button> : null }
         </div>
         <TextInput keyRef="profile_template" title="Profile" placeholder="profile_template" value={ data.value?.profile_template } handleChange={ handleChangeInput } />
         <div className="scroll nowheel">{
            mainSequencers?.map((sequencer: sequencerType, index: number) => (
               <div key={ index.toString() } className={`item ${sequencer.isMinimize ? 'minimize' : ''}`}>
                  <div 
                     className="title"
                     onClick={ _=> updateNodeValue(id, setNodes, { sequencers: data.value.sequencers.map((item: any) => {
                        if (item.id === sequencer.id) return { ...item, isMinimize: !item.isMinimize }
                        return item;
                     })})}
                  >
                     <FontAwesomeIcon icon={ sequencer.isMinimize ? faPlus : faMinus } />
                     <span>Sequencer { index+1 }</span>
                  </div>
                  <TextInput keyRef="message" otherKey={ sequencer.id } title="Message" placeholder="fixed_message" value={ sequencer.message } handleChange={ handleChangeInput } />
                  { !sequencer.isMinimize ? <>
                     <TextInput keyRef="objective" otherKey={ sequencer.id } title="Objective" placeholder="objective_content" value={ sequencer.objective } handleChange={ handleChangeInput } />
                     <Textarea keyRef="instructions" otherKey={ sequencer.id } placeholder="instructions" value={ sequencer.instructions } handleChange={ handleChangeInput } /> 
                     <Switch 
                        title="With RAG" value={ sequencer.isWithRag } 
                        setValue={ () => updateNodeValue(id, setNodes, { sequencers: data.value.sequencers.map((item: any) => {
                           if (item.id === sequencer.id) return { ...item, isWithRag: !item.isWithRag }
                           return item;
                        })})} 
                     />
                     { mainSequencers.length > 1 ? <div className="remove" onClick={ _=> handleAddExtractor('remove', sequencer.id) }><FontAwesomeIcon icon={ faTrashCan } /></div> : null }
                  </> : null }
               </div>
            ))   
         }</div>
         { isReturningToggle ? <div className="instance">
            <h3 className="title" style={{ backgroundColor: data.background, color: '#fff' }}>Returning Customer sequence</h3>
            <div>
               <button className={`btn1 line ${returningSequencers?.length >= 10 ? 'disabled' : ''}`}  onClick={ _=> handleAddExtractor('add', true) }>Add Sequence</button>
               <div className="scroll nowheel">{
                  returningSequencers?.map((sequencer: any, index: number) => (
                     <div key={ index.toString() } className={`item ${sequencer.isMinimize ? 'minimize' : ''}`}>
                        <div 
                           className="title"
                           onClick={ _=> updateNodeValue(id, setNodes, { sequencers: data.value.sequencers.map((item: any) => {
                              if (item.id === sequencer.id) return { ...item, isMinimize: !item.isMinimize }
                              return item;
                           })})}
                        >
                           <FontAwesomeIcon icon={ sequencer.isMinimize ? faPlus : faMinus } />
                           <span>Sequencer { index+1 }</span>
                        </div>
                        <TextInput keyRef="message" otherKey={ sequencer.id } title="Message" placeholder="fixed_message" value={ sequencer.message } handleChange={ handleChangeInput } />
                        { !sequencer.isMinimize ? <>
                           <TextInput keyRef="objective" otherKey={ sequencer.id } title="Objective" placeholder="objective_content" value={ sequencer.objective  } handleChange={ handleChangeInput } />
                           <Textarea keyRef="instructions" otherKey={ sequencer.id } placeholder="instructions" value={ sequencer.instructions } handleChange={ handleChangeInput } /> 
                           <Switch 
                              title="With RAG" value={ sequencer.isWithRag } 
                              setValue={ () => updateNodeValue(id, setNodes, { sequencers: data.value.sequencers.map((item: any) => {
                                 if (item.id === sequencer.id) return { ...item, isWithRag: !item.isWithRag }
                                 return item;
                              })})} 
                           />
                           { returningSequencers.length > 1 ? <div className="remove" onClick={ _=> handleAddExtractor('remove', sequencer.id) }><FontAwesomeIcon icon={ faTrashCan } /></div> : null }
                        </> : null }
                     </div>
                  ))   
               }</div>
            </div>
         </div> : null}
         { isWebsiteToggle ? <div className="instance website">
            <h3 className="title" style={{ backgroundColor: data.background, color: '#fff' }}>Add to your website</h3>
            <div>
               <span>Embed this code into your website (HTML):</span>
               <Textarea value={`<!------- Start Setup Dragify Chatbot ------->
<style>
   #dragify_chatbot img:hover { opacity: 0.8 }
   #dragify_chatbot .hide { display: none; }
</style>
<div id="dragify_chatbot" style="display: flex; flex-direction: column; align-items: flex-end; position: fixed; bottom: 30px; right: 30px; z-index: 99999999;">
   <iframe class="hide" src="${window.origin}/chatbot?projectId=${searchParams.get('id')}&blockId=${id}&blockInx=${data.index}" width="300px" height="400px" style="border-radius: 15px; border: none; box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);"></iframe>
   <img 
      src="https://dragify-file-uploader.s3.us-east-1.amazonaws.com/1742812225924_chatbot.png" 
      style="width: 80px; filter: drop-shadow(0 0 1px #000); margin-top: 15px; cursor: pointer; transition: all .2s ease-in-out;" alt="chatbot" 
   />
</div>
<script>
   document.querySelector('#dragify_chatbot img').addEventListener('click', () => {
      document.querySelector('#dragify_chatbot iframe').classList.toggle('hide');
   });
</script>
<!------- End Setup Dragify Chatbot ------->`}></Textarea>
            </div>
         </div> : null }
         </Styled></ExpandedBlock> : null}
      </Main>
   </>);
}